import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';
import { Button, Typography } from '@prenuvo/halo';

import { ReportIssueButton } from '@/core/report-issue';

export function ErrorBoundaryRoute() {
  const error = useRouteError();
  const navigate = useNavigate();

  if (isRouteErrorResponse(error)) {
    return (
      <div className="flex size-full flex-col gap-4 p-12">
        <Typography
          as="h1"
          translationKey="FCT.ERROR_BOUNDARY.ROUTE.TITLE"
          values={{ title: `${error.status} - ${error.statusText}` }}
          variant="h4"
        />

        <Typography
          translationKey={
            error.data?.message
              ? 'FCT.ERROR_BOUNDARY.ROUTE.MESSAGE.DEFAULT'
              : 'FCT.ERROR_BOUNDARY.ROUTE.MESSAGE.UNKNOWN'
          }
          values={error.data?.message ? { message: error.data?.message } : undefined}
        />

        <div className="flex items-center gap-2">
          <ReportIssueButton buttonSize="md" />

          <Button
            onClick={() => navigate(-1)}
            translationKey="FCT.ERROR_BOUNDARY.ACTION.GO_BACK"
            variant="primary"
          />
        </div>
      </div>
    );
  }

  return (
    <div className="flex size-full flex-col gap-4 p-12">
      <Typography
        as="h1"
        className="pb-4"
        translationKey="FCT.ERROR_BOUNDARY.UNKNOWN.TITLE"
        variant="h4"
      />
      <Typography translationKey="FCT.ERROR_BOUNDARY.UNKNOWN.MESSAGE" />

      <Typography
        className="dark:text-red-500"
        translationKey={
          error instanceof Error
            ? 'FCT.ERROR_BOUNDARY.UNKNOWN.ERROR.STACK'
            : 'FCT.ERROR_BOUNDARY.UNKNOWN.ERROR.UNKNOWN_ERROR'
        }
        values={error instanceof Error ? { stack: error.stack } : undefined}
        variant="paragraph-md"
      />

      <div className="flex items-center gap-2 pt-10">
        <ReportIssueButton buttonSize="md" />

        <Button
          onClick={() => globalThis.location.reload()}
          translationKey="FCT.ERROR_BOUNDARY.ACTION.REFRESH_PAGE"
          variant="primary"
        />
      </div>
    </div>
  );
}
